import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Logo from '../assets/images/logo.svg'
import { Parallax } from 'react-scroll-parallax'

const Splash = ({ desktopImage, mobileImage }) => {

  React.useEffect(() => {
    setTimeout(() => {
      document.querySelector('.splash__logo').classList.add('splash__logo--fade-in')
    }, 1000)
  }, [])


  return (
    <section className='splash'>
      <Parallax className='splash__bg-wrapper' translateY={['1px', '-100px']}>
        { mobileImage?.localFile && <GatsbyImage className='splash__bg splash__bg--mobile' image={getImage(mobileImage?.localFile)} alt='Atollon' /> }
        { desktopImage?.localFile && <GatsbyImage className='splash__bg splash__bg--desktop' image={getImage(desktopImage?.localFile)} alt='Atollon' /> }
      </Parallax>
      <Parallax className='splash__logo-wrapper' translateY={['-300px', '300px']}>
        <img 
          className='splash__logo'
          src={Logo}

          alt='Atollon'
        />
      </Parallax>
    </section>
  )
}

export default Splash